import script from "./sw-item-viewer-table.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-viewer-table.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-viewer-table.vue?vue&type=style&index=0&id=d1f0616e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1f0616e"]])

export default __exports__